<template>
	<section class="products">
		<div class="products__wrapper insicht insicht--fade-in insicht--fast">

			<Loader
				class="products__loader"
				:show="productsLoading && !loading"
			/>

			<LastOrders
				v-if="isLoggedIn && showFavorites"
				:orders="lastOrdersFiltered"
				class="products__last-orders"
				@click="onLastOrderClick"
			/>

			<h2
				class="products__title"
				v-if="isLoggedIn && favoriteProducts.length && showFavorites"
				v-html="$t('shoplist.favorites.title')"
			/>

			<div
				class="products__grid"
				v-if="products && !productsLoading"
			>
				<div
					class="products__grid-empty"
					v-if="initialized && !productsEnhanced.length"
					v-html="$t('shoplist.noProducts')"
				/>
				<!-- loop -->
				<ShoplistProduct
					v-for="(product, index) in productsEnhancedLimited"
					:key="product.code"
					:product="product"
					:locked="lockedProducts[product.code]"
					@addToCart="onAddToCart"
					@config="onConfig"
					@click="onClickProduct"
				/>
				<!-- loop end -->
				<ShoplistStaticDumplings
					v-if="showStaticInfo1"
					bg-color="purple"
					illustration="box"
					:title="$te('shoplist.static.1.title') ? $t('shoplist.static.1.title') : null"
					:text="$te('shoplist.static.1.text') ? $t('shoplist.static.1.text') : null"
					:link-text="$te('shoplist.static.1.buttonText') ? $t('shoplist.static.1.buttonText') : null"
					:link-url="$te('shoplist.static.1.buttonUrl') ? $t('shoplist.static.1.buttonUrl') : null"
				/>
				<ShoplistStaticDumplings
					v-if="showStaticInfo2"
					bg-color="yellow"
					illustration="steaming-bamboo"
					:title="$te('shoplist.static.2.title') ? $t('shoplist.static.2.title') : null"
					:text="$te('shoplist.static.2.text') ? $t('shoplist.static.2.text') : null"
					:link-text="$te('shoplist.static.2.buttonText') ? $t('shoplist.static.2.buttonText') : null"
					:link-url="$te('shoplist.static.2.buttonUrl') ? $t('shoplist.static.2.buttonUrl') : null"
				/>
				<ShoplistStaticDumplings
					v-if="showStaticInfo3"
					bg-color="green"
					illustration="chopsticks"
					:title="$te('shoplist.static.3.title') ? $t('shoplist.static.3.title') : null"
					:text="$te('shoplist.static.3.text') ? $t('shoplist.static.3.text') : null"
					:link-text="$te('shoplist.static.3.buttonText') ? $t('shoplist.static.3.buttonText') : null"
					:link-url="$te('shoplist.static.3.buttonUrl') ? $t('shoplist.static.3.buttonUrl') : null"
				/>
			</div>
		</div>

		<MobileStickyCart/>
		<Modal
			ref="modal"
			overlay-type="product-detail"
			no-close
			no-padding
			full-screen
		>
			<OverlayProduct
				v-if="modalProduct"
				:product="modalProduct"
				:locked="lockedProducts[modalProduct.code]"
				@close="onModalProductClose"
				@addToCart="onAddToCart"
				@config="onConfig"
			/>
		</Modal>
		<OverlayError/>
		<OverlayChildProducts
			v-if="hasFeature('FEATURE_CHILDPRODUCTS')"
			ref="childproductsOverlay"
			@edit="onChildProductsEdit"
			@add="onChildProductsAdd"
		/>
	</section>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import scrrroll from 'scrrroll'
import urlWatcher from '@/helpers/urlwatcher'
import GenericMixin from '@/mixins/GenericVueMixin'
import ProductListMixin from '@/mixins/ProductListVueMixin'
import OverlayError from '@/pages/OverlayError';
import ShoplistFilter from '@/components/ShoplistFilter'
import ShoplistProduct from '@/components/ShoplistProduct'
import ShoplistStaticDumplings from '@/components/ShoplistStaticDumplings'
import ShoplistCategory from '@/components/ShoplistCategory'
import OverlayProduct from '@/pages/OverlayProduct'
import OverlayChildProducts from '@/pages/OverlayChildProducts'
import MobileStickyCart from '@/components/MobileStickyCart'
import Button from '@/components/Button'
import Modal from '@/components/Modal'
import ListScrollPane from '@/components/ListScrollPane'
import Loader from '@/components/Loader';
import LastOrders from '@/components/LastOrders';
import htmlComponent from "htmlcomponent"
import {eventhub, EVENT_CART_TIMECHANGED, EVENT_SHOP_INITIALIZED} from '@/store/eventhub'

export default {
	mixins: [
		GenericMixin,
		ProductListMixin,
	],
	components: {
		OverlayError,
		ShoplistFilter,
		ShoplistProduct,
		ShoplistStaticDumplings,
		ShoplistCategory,
		OverlayProduct,
		OverlayChildProducts,
		MobileStickyCart,
		Button,
		Modal,
		ListScrollPane,
		Loader,
		LastOrders,
	},
	data() {
		return {
			initialized: false,
			showFavorites: false,
			modalProduct: null,
			modalProductCode: null,
			categoryScrollStart: false,
			categoryScrollEnd: false,
			productLoadThresholdMin: 30,
			productLoadThresholdProgression: 5,
			productLoadThresholdMax: 90,
      productsPerPage: 10,
      productPagesLoaded: 1,
			staticDumplingsInfoTaxons: ['all', 'dumplings', 'alluk', 'dumplingsuk'],
			specialProductTaxons: ['all', 'dumplings', 'alluk', 'dumplingsuk'],
			specialProductIndex: 2,
		}
	},
	computed: {
		...mapGetters("productlist", [
			"products",
			"categories",
			"filters",
			"filtersActive",
			"currentTaxon",
			"currentTaxonPath",
			"currentSubCategories",
			"favoriteCode",
			"productsLoading",
		]),
		...mapGetters("account", [
			"isLoggedIn",
			"lastOrders",
			"favoriteProducts",
			"accountUserDetail",
			"accountGroupCodes",
		]),
		...mapGetters('cart', [
			'hasBasket',
			"shippingMethod",
		]),
		...mapGetters('loader', [
			'isLoading',
		]),
		loading: {
			set(value) {
				this.$store.dispatch('loader/setLoading', value);
				this.$emit('loading', value);
			},
			get() {
				return this.isLoading;
			}
		},
		showStaticInfo1() {
			return this.staticDumplingsInfoTaxons.includes(this.currentTaxon) && this.productsEnhancedLimited.length;
		},
		showStaticInfo2() {
			return this.staticDumplingsInfoTaxons.includes(this.currentTaxon) && this.productsEnhancedLimited.length >= 6;
		},
		showStaticInfo3() {
			return this.staticDumplingsInfoTaxons.includes(this.currentTaxon) && this.productsEnhancedLimited.length >= 16;
		},
		activeCategory() {
			return this.currentTaxon == this.favoriteCode ? this.favoriteCode : this.currentTaxonPath[0] && this.currentTaxonPath[0].code
		},
		activeSubCategory() {
			return this.currentTaxonPath.length > 1 ? this.currentTaxonPath[1].code : ""
		},
		showSubCategories() {
			return this.currentSubCategories.length > 0
		},
		showPersonalStartpage() {
			return !!(this.isLoggedIn && (this.favoriteProducts.length || this.lastOrders.length));
		},
		productsLimit() {
      return this.productPagesLoaded * this.productsPerPage;
    },
		productPagesMax() {
			return Math.ceil(this.productsEnhanced.length / this.productsPerPage)
		},
		productLoadThreshold() {
			return Math.min(this.productLoadThresholdMax, this.productLoadThresholdMin + (this.productLoadThresholdProgression * (this.productPagesLoaded - 1)));
		},
		productsEnhanced() {
			let filterIds = this.filtersActive

			//check favorite products
			//TODO: currently done the easy way, but it may have implications if we toss in the normal products
			let products = this.showFavorites ? this.favoriteProducts : this.products
			const specialProductIndex = this.specialProductTaxons.includes(this.currentTaxon)
				? this.specialProductIndex
				: -1;

			return this
				.enhanceProducts(products, specialProductIndex)
				.filter(product =>
					filterIds.length > 0
						? filterIds.reduce((p, c) => p && product.tags.includes(c), true)
						: true
				)
		},
		productsEnhancedLimited() {
			return this.productsEnhanced.slice(0, this.productsLimit)
		},
		lastOrdersFiltered() {
			return this.lastOrders
				// TODO: re-evaluate in the future
				// .filter(order => order.shipmentCode === this.shippingMethod.code)
				.slice(0,3);
		},
	},
	watch: {
		products(val) {
			this.productPagesLoaded = 1;
		}
	},
	methods: {
		onClickProduct(code) {
			urlWatcher.change({ taxon: this.currentTaxon, product: code })
		},
		onFavoriteProducts() {
			urlWatcher.change({"taxon": this.favoriteCode})
		},
		onModalProductOpen(code) {
			this.modalProduct = this.getProduct(code)
			this.modalProductCode = code
			if (this.modalProduct) {
				this.$refs.modal.open()
			}
			else {
				this.$refs.modal.close()
			}
		},
		onModalProductClose() {
			urlWatcher.change({ product: null })
			this.$refs.modal.close();
			this.modalProduct = null
			this.modalProductCode = null
		},
		async onHashChange(params) {
			if (params.taxon) {
				const category = params.taxon

				if (category !== this.activeCategory) {
					scrrroll.to(0, 300)

					if (category == this.favoriteCode) { //TODO: check what happens with logged in vs non
						this.showFavorites = true
						//HACK: this commit should not be here, but its marked for future cleanup
						this.$store.commit('productlist/setActiveCategory', { item: this.favoriteCode })
						await this.$store.dispatch('account/loadFavoriteProducts')
							// HACK: favorite Products currently fail on the live system, so we ignore the error
							.catch(err => Promise.resolve("Silent Fail currently"))

					} else {
						this.showFavorites = false
						try {
							await this.$store.dispatch('productlist/loadProductList', {taxon: category})
						}
						catch(err) {
							this.$store.dispatch('dialog/showDialog', {
								title: this.$t('forms.errors.error'),
								message: this.$t('forms.errors.generic'),
								confirm: 'OK',
							});
						}
					}
				}
			}
			if (params.product) {
				this.onModalProductOpen(params.product)
			}
		},
		async onFilterChange(filterId, active) {
			// TODO: set the filters in onHashChange for deeplinking and browser history handling
			await this.$store.dispatch('productlist/setFilter', {filterId, active})
			urlWatcher.change({filters: this.filtersActive.join(",")})
		},
		async onLastOrderClick(token) {
			// TODO: this should trigger the process to reorder products from order with token XXX
			await this.$store.dispatch('redoOrder', { token })
			// console.info('last order has been opened %s -> %s', token, this.$store.state.cart.basketToken)
		},
		onLoginClick() {
			htmlComponent.send('overlay:open', {type: 'login'});
		},
		async onCartTimechanged() {
			this.loading = true
			await this.$store.dispatch('updateShoplist')
			this.loading = false
		},
		async onChildProductsAdd(product, childCodes) {
			this.loading = true;
			try {
				const item = {
						"quantity": 1,
						"productCode": product.code,
						"variantCode": product.selectedVariant,
						"childCodes": childCodes,
						"forceCopy": true,
				};
				await this.onAddToCart(item);
				this.$refs.childproductsOverlay.close()
			}
			catch(err) {
				this.$store.dispatch('error/errorShow');
			}
			this.loading = false;
		},
		async onChildProductsEdit(item, childCodes) {
			this.loading = true;
			try {
				await this.$store.dispatch('childproducts/adjustChildProducts', { item: item, childCodes }, { root: true })
				this.$refs.childproductsOverlay.close()
			}
			catch(err) {
				this.$store.dispatch('error/errorShow');
			}
			this.loading = false;
		},
		onContentScroll() {
      if (this.productPagesLoaded < this.productPagesMax) {
				const scrollTop = window.pageYOffset;
				const scrollHeight = document.documentElement.scrollHeight - window.innerHeight;
				const scrollProgress = Math.min(Math.max(((scrollTop / scrollHeight) * 100), 0), 100);

				if (scrollProgress > this.productLoadThreshold) {
					this.productPagesLoaded = Math.min(this.productPagesMax, this.productPagesLoaded + 1);
				}
			}
    },
		onShopInitialized() {
			const params = urlWatcher.readUrl()
			this.onHashChange(params)
			urlWatcher.addListener(this.onHashChange)
		}
	},
	async created() {
		this.initialized = false;
		this.loading = true
		await this.$store.dispatch('initializeShoplist')
		this.loading = false
		const params = urlWatcher.readUrl()
		this.onClickProduct(params.product);
		this.initialized = true;
	},
	mounted() {
		eventhub.$on(EVENT_CART_TIMECHANGED, this.onCartTimechanged)
		eventhub.$on(EVENT_SHOP_INITIALIZED, this.onShopInitialized)
		window.addEventListener('scroll', this.onContentScroll);
	},
	destroyed() {
		urlWatcher.removeListener(this.onHashChange)
		eventhub.$off(EVENT_CART_TIMECHANGED, this.onCartTimechanged)
		eventhub.$off(EVENT_SHOP_INITIALIZED, this.onShopInitialized)
		window.removeEventListener('scroll', this.onContentScroll);
	}
};
</script>

<style>
</style>
